import React, { useState, useEffect, useContext } from "react";
import Icon from "../../_default/Icon";
import SearchPage from "../../_default/SearchPage";
import "./ChatList.scss";
import Select from "react-select"
import Chat from "../Chat";
import UserContext from "../../../services/context/userContext";
export default function ChatList({ msgSent,setMsgSent, opnChat,setOpnChat, style, clientsList, Time, fulltime, shortFulltime }) {
  const [showPopup, setShowPopup] = useState(false);
  let [searchClient,setSearchClient]=useState("")
  let [clients,setClients]=useState([])
  // const [opnChat,setOpnChat]=useState(false)
  const [chatId,setChatId]=useState("")
  const [clientName,setClientName]=useState("")
  const [clientProfilePhoto,setClientProfilePhoto]=useState("")
  const user = useContext(UserContext);
  useEffect(()=>{
    setClients(clientsList)
    // console.log("lsit",clientsList)
    if (searchClient) {
      const results = clients.filter((client) => {
        if (searchClient === "") return clients;
        return (client.first_name + " " + client.last_name)
          .toLowerCase()
          .includes(searchClient.toLowerCase());
      });
      setClients(results);
      // console.log("filter client info", results, clientInfo)
    }
    // let filter=clientsList.filter((data)=>data.first_name+" "+data.last_name==searchClient)
    // if(searchClient.length>0){
    //     setClients(filter)
    //     // setLoading(false)
    //     console.log("filter clients",filter)
    // }else{
    //     setClients(clientsList)

    //     // setLoading(false)
    // }
  },[searchClient,clientsList])
  const chatBoxStyle={
    width: "370px",
    height: "376px",
    /* margin-top: 30px; */
    borderRadius: "26px",
    /* padding: 0px; */
    /* margin-right: 20px; */
    flexDirection: "column",
    /* max-height: calc(100vh - 160px); */
    borderRadius: "20px",
    /* overflow: scroll; */
    position: "relative",
    /* padding-bottom: 10px; */
    /* flex: 0 0 290px; */
    display: "flex",
    marginTop:"unset",
    
  }
  const searchBoxStyle={
    borderRadius: "9px",
    width: "280px",
    height: "50px",
    position:"absolute"
  }
  return (
    <>
    
      <div
        className="c-todolist"
        style={{
          // overflowY: "scroll",
          // height: "400px",
        //   borderRight: "solid",
        //   borderColor: "#3232",
          marginTop: "12px",
          marginBottom: "12px",
        //   borderRadius: "3px",
        // width:"352px",
        paddingRight:"7px",
        display:"flex",
        paddingTop:"unset",
        }}
      >
        <div style={{marginRight:"20px"}}>
            <h3 style={{fontWeight:"700"}} >Inbox</h3>
            {/* <Select 
            options={clients.map((data)=>({
                value: data.userID,
                label: data.first_name+" "+data.last_name ,
  
              }))
            } 
            onChange={(e)=>{setSearchClient(e.label)}} 
            placeholder="Search client" 
            isSearchable={true}
            /> */}
            <div>

            <SearchPage style={searchBoxStyle} placeholder="Search client" value={searchClient} onChange={(e)=>{setSearchClient(e.target.value)}}  />
            </div>
            {/* <hr /> */}
              <div style={{height:"400px",overflowY:"scroll",marginTop:"54px"}}>
            {
                clients.map((client)=>{
                  
                  // ()=>setOpnChat(true)
                    return<> 
                 
                    <div   onClick={()=>{setChatId(client.id);setClientProfilePhoto(client.image);setOpnChat(true);setClientName(client.first_name+" "+client.last_name)}} className="c-appointment" style={{ justifyContent:"space-between",cursor:"pointer",margin:"unset",padding:"unset",height:"77px" }}>
                    <div style={{ display: "flex",alignItems:"center" }}>
                    {client.image?DisplayImage(client.image):DisplayIcon("users") }
                   <div className="c-clients-profile-text-custom">
                     <p className="c-client-ibx-name">{client.first_name+" "+client.last_name}</p>
                    {((client.senderID!==user.id)&&(client.ack==false))?
                     <span><Icon  icon="red-dot" /></span>:""
                    }
                   </div>
                 </div>
                 {/* <div style={{ display: "flex" }}>
                 <div className="c-time">
                 
                 </div>
               
               </div> */}
            </div>
                     </>
                })
            }
                </div>
      </div>
            { opnChat&&
            <>
      <div style={{position: "relative",
    left: "392px",
    zIndex: "2",
    top: "14px",
    cursor:"pointer"}} onClick={()=>setOpnChat(false)} ><Icon icon="cancel" /></div>
      <div
      className="c-todolist"
      style={{
        padding:"unset",
        width:"unset",
        backgroundColor:"white",
        height:"417px",
        borderRadius:"9px",
        marginTop:"14px",
      }}
     
    >
      <div style={{display:"flex",alignItems:"center"}}>
        <div style={{paddingLeft:"10px"}}>{clientProfilePhoto?DisplayImage(clientProfilePhoto):DisplayIcon("users")}</div>
        <span style={{fontSize:"15px"}}> {clientName}</span>
        {/* <button style={{marginLeft:"5px"}} className="c-cancel-btn" onClick={()=>setOpnChat(false)}>
                  Cancel
                </button> */}
        {/* <button onClick={()=>setOpnChat(false)} >Back</button> */}
      </div>
        
      <hr />
        <Chat msgSent={msgSent} setMsgSent={setMsgSent} customStyle={chatBoxStyle}  client_id={chatId}/>




      
       
      </div>
      </>
      
      }
              
              
      </div>
    
      
    </>
  );
}

function DisplayIcon(icon) {
  // debugger;
  return (
    <div className="c-chat-profile">
      <Icon icon={icon} color="#fff" size="35px" />{" "}
      {/* <div className="c-active-icon"></div> */}
    </div>
  );
}

function DisplayImage(image) {
  return (
    <div
      className="c-chat-profile"
      style={{ backgroundImage: `url('${image}')` }}
    >
      {/* <div className="c-active"></div> */}
    </div>
  );
}
